/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
/* eslint-disable no-shadow */
/* eslint-disable comma-dangle */
/* eslint-disable spaced-comment */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-duplicates */
/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import Cookies from 'js-cookie';
import alertActions, { toastError } from './alertActions';
import { userConstants } from '../constants/userConstants';
import { userServices } from '../services/userServices';
import { companyServices } from '../services/companyServices';
import { edusignServices } from '../services/edusignServices';

import { groupActions } from './groupActions';

function createUser(user) {
  function request(userRequest) {
    return {
      type: userConstants.CREATE_USER_REQUEST,
      userRequest,
    };
  }

  function success(userSuccess) {
    return {
      type: userConstants.CREATE_USER_SUCCESS,
      user: userSuccess,
    };
  }

  function failure(error) {
    return {
      type: userConstants.CREATE_USER_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    const newUser = {
      email: user.email,
      password: user.password,
      firstname: user.firstname,
      name: user.name,
      type: user.type,
      jobTitle: user.jobTitle ? user.jobTitle : null,
      phone: user.phone ? user.phone : null,
      needs: user.needs ? user.needs : null,
      company: user.company,
      semester: 1,
      code: user.code,
      placementtest: user.placementtest
    };
    dispatch(request(newUser));
    return userServices.createUser(newUser)
      .then(
        async (auth) => {
          localStorage.setItem('auth', JSON.stringify(auth));
          await dispatch(getStudent(auth._id, null));
          await dispatch(success(auth));
        },
        (error) => {
          dispatch(failure(error.toString()));
          toastError(error.toString());
        },
      );
  };
}

function confirmAccount(id, code) {
  function confirmRequest() { return { type: userConstants.CONFIRM_REQUEST }; }
  function confirmSuccess(user) { return { type: userConstants.CONFIRM_SUCCESS, user }; }
  function confirmFailure(error) { return { type: userConstants.CONFIRM_FAILURE, error }; }

  return (dispatch) => {
    dispatch(confirmRequest());
    return userServices.verifyAccount(id, code)
      .then(
        async (auth) => {
          const isAuth = !!localStorage.getItem('auth');
          if (isAuth) {
            localStorage.setItem('auth', JSON.stringify(auth));
            const expiring = new Date();
            expiring.setMinutes(60 * 5 + 5);
            Cookies.set('auth', auth.token, { expires: null }, { secure: true }, { sameSite: 'strict' });
            Cookies.set('refresh', auth.refreshToken, { expires: 365 }, { secure: true }, { sameSite: 'strict' });
            if (!auth.testFinish) await dispatch({ type: userConstants.SET_TEST });
            await dispatch(getUser(auth._id));
            await dispatch(groupActions.getGroup(auth._id));
            dispatch(confirmSuccess(auth));
          }
        },
        (error) => {
          dispatch(confirmFailure(error.toString()));
          dispatch(alertActions.error(new Error('Impossible de vous connecter, verifiez vos identifiants.')));
        },
      )
      .catch(() => {
      });
  };
}

function loginGetUser(username, password, rememberMe, type) {
  return (dispatch, getState) => dispatch(login(username, password, rememberMe, type))
    .then(
      async () => {
        let isBlocked = false;
        if (getState().authentication && getState().authentication.auth.company) {
          await companyServices.getCompanyById(getState().authentication.auth.company)
            .then((res) => {
              isBlocked = res.loginBlocked;
            });
        }
        if (isBlocked) {
          dispatch(loginFailure('Company Blocked'));
          logout();
          toastError('Votre accès est temporairement suspendu, veuillez vous référer à EnglishWorld afin de régulariser votre situation.');
          return 'Company Blocked';
        }
        if (!getState().authentication.auth.testFinish) await dispatch({ type: userConstants.SET_TEST });
        const authentication = await getState().authentication.auth;
        localStorage.setItem('auth', JSON.stringify(authentication));
        return dispatch(getUser(authentication._id, true));
      },
      (error) => {
        dispatch(loginFailure(error.toString()));
        toastError(error.toString());
      },
    );
  function loginFailure(error) { return { type: userConstants.LOGIN_FAILURE, error }; }
}

function login(username, password, rememberMe, type) {
  function loginRequest() { return { type: userConstants.LOGIN_REQUEST }; }
  function loginSuccess(auth) { return { type: userConstants.LOGIN_SUCCESS, auth }; }
  function loginFailure(error) { return { type: userConstants.LOGIN_FAILURE, error }; }
  return (dispatch) => {
    dispatch(loginRequest({ username }));
    return userServices.login(username, password, rememberMe, type)
      .then(
        async (logged) => {
          if (logged.company) {
            await companyServices.getCompanyById(logged.company)
              .then((res) => {
                if (!res.loginBlocked) {
                  userServices.generateLoginToken(logged);
                }
              });
          }
          if (logged.type === 3) {
            userServices.generateLoginToken(logged);
          }
          dispatch(loginSuccess(logged));
        },
        (error) => {
          dispatch(loginFailure(error.toString()));
          toastError('Erreur de connexion, veuillez vérifier vos identifiants');
        },
      );
  };
}

function impersonateLogin1(userEmail, password, rememberMe, type, adminMail) {
  function loginRequest() { return { type: userConstants.LOGIN_REQUEST }; }
  function loginSuccess(auth) { return { type: userConstants.LOGIN_SUCCESS, auth }; }
  function loginFailure(error) { return { type: userConstants.LOGIN_FAILURE, error }; }
  return (dispatch) => {
    dispatch(loginRequest({ username: userEmail }));
    return userServices.impersonateLogin(
      adminMail,
      userEmail,
      password,
      rememberMe,
      type
    )
      .then(
        async (logged) => {
          if (logged.company) {
            await companyServices.getCompanyById(logged.company)
              .then((res) => {
                if (!res.loginBlocked) {
                  userServices.generateLoginToken(logged);
                }
              });
          }
          if (logged.type === 3) {
            userServices.generateLoginToken(logged);
          }
          dispatch(loginSuccess(logged));
        },
        (error) => {
          dispatch(loginFailure(error.toString()));
          toastError('Erreur de connexion, veuillez vérifier vos identifiants');
        },
      );
  };
}

function impersonateLogin(userEmail, password, rememberMe, type, adminMail) {
  return (dispatch, getState) => dispatch(impersonateLogin1(userEmail, password, rememberMe, type, adminMail))
    .then(
      async () => {
        let isBlocked = false;
        if (getState().authentication && getState().authentication.auth.company) {
          await companyServices.getCompanyById(getState().authentication.auth.company)
            .then((res) => {
              isBlocked = res.loginBlocked;
            });
        }
        if (isBlocked) {
          dispatch(loginFailure('Company Blocked'));
          logout();
          toastError('Votre accès est temporairement suspendu, veuillez vous référer à EnglishWorld afin de régulariser votre situation.');
          return 'Company Blocked';
        }
        if (!getState().authentication.auth.testFinish) await dispatch({ type: userConstants.SET_TEST });
        const authentication = await getState().authentication.auth;
        localStorage.setItem('auth', JSON.stringify(authentication));
        return dispatch(getUser(authentication._id, true));
      },
      (error) => {
        dispatch(loginFailure(error.toString()));
        toastError(error.toString());
      },
    );
  function loginFailure(error) { return { type: userConstants.LOGIN_FAILURE, error }; }
}

function getUser(userId, login) {
  return (dispatch) => {
    dispatch(request(userId));
    return userServices.getUserById(userId)
      .then(
        async (user) => {
          if (!login) {
            sessionStorage.setItem('user', JSON.stringify(user));
          } else {
            localStorage.setItem('user', JSON.stringify(user));
          }
          dispatch(success(user));
        },
        (error) => {
          dispatch(failure(error.toString()));
          toastError(error.toString());
        },
      );
  };

  function request(user) { return { type: userConstants.GET_USER_REQUEST, user }; }
  function success(user) { return { type: userConstants.GET_USER_SUCCESS, user }; }
  function failure(error) { return { type: userConstants.GET_USER_FAILURE, error }; }
}

function setUser(userId, login) {
  return userServices.getUserById(userId)
    .then(
      (user) => {
        if (!login) {
          sessionStorage.setItem('user', JSON.stringify(user));
        } else {
          localStorage.setItem('user', JSON.stringify(user));
        }
      },
      (error) => {
        toastError(error.toString());
      },
    );
}

function getStudent(userId, login) {
  return (dispatch, getState) => {
    dispatch(request(userId));
    userServices.getStudentById(userId)
      .then(
        (user) => {
          if (!login) {
            sessionStorage.setItem('user', JSON.stringify(user));
          } else {
            localStorage.setItem('user', JSON.stringify(user));
          }
          dispatch(success(user));
        },
        (error) => {
          dispatch(failure(error.toString()));
          // toastError(error.toString());
        },
      );
  };

  function request(user) { return { type: userConstants.GET_USER_REQUEST, user }; }
  function success(user) { return { type: userConstants.GET_USER_SUCCESS, user }; }
  function failure(error) { return { type: userConstants.GET_USER_FAILURE, error }; }
}

function refreshLogin(email) {
  return (dispatch, state) => {
    dispatch(refreshRequest({ email }));
    return userServices.refreshAuth(email, state().authentication.auth.refreshToken)
      .then(
        (logged) => {
          userServices.generateLoginToken(logged);
          dispatch(refreshSuccess(logged));
        },
        (error) => {
          dispatch(refreshFailure(error.toString()));
          toastError(error.toString());
        },
      );
  };

  function refreshRequest() { return { type: userConstants.LOGIN_REFRESH_REQUEST }; }
  function refreshSuccess(auth) { return { type: userConstants.LOGIN_REFRESH_SUCCESS, auth }; }
  function refreshFailure(error) { return { type: userConstants.LOGIN_REFRESH_FAILURE, error }; }
}

function logout() {
  return (dispatch) => {
    dispatch({ type: 'USERS_LOGGED_OUT' });
    userServices.logout();
    // localStorage.clear();
  };
}

function forgotPassword(email) {
  return (dispatch) => {
    dispatch(passwordRequest(email));
    userServices.forgotPassword(email)
      .then(
        (success) => {
          dispatch(passwordSuccess());
        },
        (error) => {
          dispatch(passwordFailure(error.toString()));
          toastError(error.toString());
        },
      );
  };
  function passwordRequest(email) { return { type: userConstants.REQUEST_NEW_PASSWORD, email }; }
  function passwordSuccess() { return { type: userConstants.SUCCESS_NEW_PASSWORD }; }
  function passwordFailure(error) { return { type: userConstants.FAILURE_NEW_PASSWORD, error }; }
}

function updateUser(userId, body) {
  return (dispatch, state) => {
    dispatch(refreshRequest(body));
    return userServices.updateUser(userId, body)
      .then(
        (success) => {
          dispatch(refreshSuccess());
        },
        (error) => {
          dispatch(refreshFailure(error.toString()));
          toastError(error.toString());
        },
      );
  };
  function refreshRequest(data) { return { type: userConstants.REQUEST_UPDATE_USER, data }; }
  function refreshSuccess() { return { type: userConstants.SUCCESS_UPDATE_USER }; }
  function refreshFailure(error) { return { type: userConstants.FAILURE_UPDATE_USER, error }; }
}

export const setEdusignUserId = (id) => ({
  type: userConstants.SET_EDUSIGN_USER_ID,
  payload: id,
});

export const userActions = {
  loginGetUser,
  login,
  createUser,
  confirmAccount,
  logout,
  forgotPassword,
  getStudent,
  getUser,
  refreshLogin,
  updateUser,
  setUser,
  setEdusignUserId,
  impersonateLogin
  //delete: _delete
};
